import { getAuditLog, searchAuditLogs } from '@infuse/api/audit-log';
import { FilterExpression } from '@infuse/api/common';
import { defineStore } from 'pinia';
import { apiResultToDomain } from './conversion';
import { aggregateSearchQueryAndFilters, State } from './filtering';
import { AuditLog } from './model';

export const useAuditLogStore = defineStore('audit-log', {
  state: () => {
    return {
      items: [],
      options: {
        query: '',
        filter: undefined,
        page: 0,
        lastPage: false
      },
      loading: false,
      loadingGet: false
    } as State;
  },
  getters: {},
  actions: {
    async search() {
      this.loading = true;

      const apiResponse = await searchAuditLogs({
        sort: [{ key: 'createdAt', descending: true }],
        size: 20,
        filter: aggregateSearchQueryAndFilters(this.options),
        page: this.options.page
      });

      this.loading = false;

      this.options.lastPage = apiResponse.last;

      const responseItems = apiResponse.content ? apiResponse.content.map(apiResultToDomain) : [];

      if (apiResponse.first) {
        this.items = responseItems;
      } else {
        this.items = [...this.items, ...responseItems];
      }
    },

    setSearchQuery(searchQuery: string) {
      this.resetPageOptions();
      this.options.query = searchQuery;
    },

    async setFilter(filter: FilterExpression) {
      this.resetFilterOptions();
      this.options.filter = filter;

      await this.search();
    },

    async loadMore() {
      if (!this.options.lastPage) {
        this.options.page++;
        await this.search();
      }
    },

    resetFilterOptions() {
      // reset filters and pagination
      this.options.filter = undefined;
      this.resetPageOptions();
    },

    resetOptions() {
      // reset everything
      this.resetSearchOptions();
      this.resetFilterOptions();
    },

    resetPageOptions() {
      this.options.page = 0;
      this.options.lastPage = false;
      this.items = [];
    },

    resetSearchOptions() {
      // reset search bar and pagination
      this.options.query = '';
      this.resetPageOptions();
    },

    async getAuditLog(id: string): Promise<AuditLog> {
      this.loadingGet = true;
      const auditLog = apiResultToDomain(await getAuditLog({ id }));

      const index = this.items.findIndex((item) => item.id === auditLog.id);

      if (index === -1) {
        this.items.push(auditLog);
      } else {
        this.items[index] = auditLog;
      }
      this.loadingGet = false;
      return auditLog;
    }
  }
});
